<script>
// import Spinner from '../components/Spinner';

export default {
  name: 'ButtonWithLoading',
  components:{
    // Spinner,
  },
  props: ['text', 'color', 'loading', 'active', 'width'],

  computed: {
    customClasses(){
      let myClasses = "ButtonWithLoadingContainer"

      if (this.color == "green"){
        myClasses += " green"
      }

      if (this.active == false){
        myClasses += " inactive"
      }

      return myClasses
    },
    customCSS(){
      let myStyle = ""
      if (this.width){
        myStyle += "width: " + this.width + ";"
      }
      return myStyle
    }
  },
  data(){
    return{
      isLoading: this.loading
    }
  },
  methods: {
    clicked(){
      if (this.active){
        this.$emit('clicked')
      }
    }
  }
}


</script>


<template>
  <div id="ButtonWithLoadingContainer" :class="customClasses" @click="clicked" :style="customCSS">
    <span v-if="loading" class="material-icons icon spin">autorenew</span>
    <!-- <Spinner color="white" size="20px"/> -->
    <span v-else>{{text}}</span>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.ButtonWithLoadingContainer{
  @include myButton;
  font-size: 13px;
}

.green{
  background-color: $green;

  &:hover{
    box-shadow: 0px 0px 4px 2px $green-lighter;
  }
}

.inactive{
  background-color: $black-light;
  cursor: default;

  &:hover{
    box-shadow: none;
  }
}

.icon{
  display: inline-block;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: white;
  vertical-align: bottom;

  &:hover{
    color: white;
    cursor: default;
  }
}

.spin {
  -webkit-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

</style>
